import React, { cloneElement, Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { invoke } from 'lodash';

// TODO: Add as="buffer" option to FileUpload and consolidate.
class FileUpload extends Component {
  inputRef = React.createRef();

  onTriggerClick = event => {
    const { trigger } = this.props;
    invoke(trigger, 'props.onClick', event);
    invoke(this.inputRef, 'current.click');
  };

  onFileChange = event => {
    const [file] = event.target.files;

    invoke(this.props, 'onFile', file);
  };

  render() {
    const { trigger } = this.props;
    return (
      <Fragment>
        {cloneElement(trigger, {
          onClick: this.onTriggerClick,
        })}
        <input
          ref={this.inputRef}
          type="file"
          style={{ display: 'none' }}
          onChange={this.onFileChange}
          onBlur={this.onFileBlur}
        />
      </Fragment>
    );
  }
}

FileUpload.propTypes = {
  trigger: PropTypes.element.isRequired,
  onFile: PropTypes.func.isRequired,
};

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/FileUpload.js